<template>
  <div id="machine">
  <!-- 面包线导航 -->
    <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>告警中心</el-breadcrumb-item>
        <el-breadcrumb-item>空气报警</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card >
        <!-- 第一行筛选框 -->
        <el-row :gutter="20">
                <!-- 机器名查询 -->
                <el-col :span="5" >
                    <span>机器编号:</span>
                    <el-input placeholder="请输入编号" v-model="airWorkInfo.robotNo" class="m-l-30 ell-input" ></el-input>
                </el-col>
               <el-col :span="6">
                        <span>消息时间:</span>
                        <el-date-picker v-model="airWorkInfo.createTimeStr"  type="date"  value-format="yyyy-MM-dd"  placeholder="选择日期" class="m-l-30 ell-input"> </el-date-picker>
               </el-col>
               
        </el-row>
        <!-- 第二行筛选框 -->
        <el-row :gutter="20" >
                  <!-- 创建时间 -->
        
            <el-col align="middle" >
                <el-button type="primary" @click="searchAirWarn()">查询</el-button>
                <el-button type="info" @click="clearParams()">重置</el-button>
            </el-col>   
        </el-row>
        <!-- 用户列表区域 -->
        <el-table :data="airWorkList" border  stripe  :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
             <el-table-column label="机器人编号" prop="robotNo" width="150"></el-table-column>
            <el-table-column label="PM2.5" prop="pm2_5" width="100"></el-table-column>
            <el-table-column label="PM10" prop="pm10" width="100"></el-table-column>
            <el-table-column label="湿度" prop="humidity" width="150"></el-table-column>
            <el-table-column label="温度" prop="temperature" width="150"></el-table-column>
            <el-table-column label="大气压" prop="baro" width="150"></el-table-column>
            <el-table-column label="光照" prop="illumination" width="150"></el-table-column>
            <el-table-column label="挥发性" prop="tvoc" width="150"></el-table-column>
            <el-table-column label="二氧化碳" prop="co2" width="150"></el-table-column>
            <el-table-column label="甲醛" prop="hcho" width="150"></el-table-column>
            <el-table-column label="创建时间" prop="createTime" width="150"></el-table-column>
        </el-table>
       
     
         <!-- 分页区间 -->
        <el-pagination   @current-change="handleCurrentChange"  :current-page.sync="airWorkInfo.num"  
                :page-size="20"  layout="total, prev, pager, next"  :total="total">
        </el-pagination>
    </el-card >
  </div>
</template>

<script>


export default {
  name: 'machine',
  data(){
      return {
          airWorkInfo :{
              robotNo:'',
              num : 1
          },
          total:0,
          airWorkList:[],
      }
  },
   //生命周期函数
  created(){
    this.searchAirWarn()
  },
  methods:{
        //点击指定页码跳转
        handleCurrentChange(page){
            this.airWorkInfo.num=page;
            this.searchAirWarn();
        },
        clearParams(){
          this.airWorkInfo.robotNo='';
          this.airWorkInfo.createTimeStr='';
        },
        //查询日志
        searchAirWarn(){
            var zF = /[`~!@#$%^&*()_\+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）\+={}|《》？：“”【】、；‘'，。、]/
            if(zF.test(this.airWorkInfo.robotNo)){
                return this.$message.error("请输入非特殊字符!");
            }
            this.$http.post('/airWarn/selectAirWarns',JSON.stringify(this.airWorkInfo))
            .then(response => {
                    if (response.data.code === 200) {
                       this.airWorkList=response.data.result.data;
                       this.total=response.data.result.total;
                    }else{
                        return this.$message.error(response.data.message);
                    }
                }).catch(failResponse => {

            })
        },
      
  }
  
}
</script>

<style lang="less" scoped>
.el-input {
    width: 150px;
}
.ell-input {
    width: 200px;
}
.m-l-30 {
  margin-left: 30px !important;
}

.el-row {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap
}

.ell-row {
    margin-bottom: 40px;
    display: flex;
    flex-wrap: wrap
}
html,body,.XSDFXPage{
        width: 50%;
        height: 50%;
        overflow: hidden;
        margin: 0px auto;
        font-family: "微软雅黑";
}
.map {
        width: 100%;
        height: 400px;
}
.el-table{
    font-size: 10px;
    height:'20px';
    padding:'0px'
}
 
</style>


// WEBPACK FOOTER //
// src/components/robot/AirWarn.vue